const useHasVixAccess = () => {
  return true;
};
export default useHasVixAccess;
